import {
  GET_SALE_RA_ITEM_REQUEST,
  GET_SALE_RA_ITEM_SUCCESS,
  GET_SALE_RA_ITEM_ERROR

  } from "../actions/types";

  export default function (state = [], action){
    const { type, payload } = action;
    switch (type) {
      case GET_SALE_RA_ITEM_REQUEST:
        return {
          loading: true,
        };
      case GET_SALE_RA_ITEM_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_SALE_RA_ITEM_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  

  